import { useEffect, useRef, useState } from 'react';

const useNearScreen = (distance = '10px') => {
  const elementRef = useRef();
  const [isNearScreen, setIsNearScreen] = useState(true);

  useEffect(() => {
    const handleChange = (entries) => {
      setIsNearScreen(entries[0].isIntersecting);
    };

    const observer = new IntersectionObserver(handleChange, {
      rootMargin: distance,
    });

    observer.observe(elementRef.current);
    return () => observer.disconnect();
  }, []);

  return { isNearScreen, elementRef };
};

export default useNearScreen;
